<template>
  <div class="invite-form__link">
    <v-text-field
      :value="inviteLink"
      id="refLink"
      class="form-field"
      dense
      readonly
      label="Add new developer link"
      placeholder="Link"
    />
    <v-btn
      class="invite-form__link-btn"
      outlined
      fab
      tile
      color="blue"
      @click="copy"
    >
      <v-icon dark>mdi-link-variant</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { copyToClipboard } from '@/helpers/utils';

const pageUrl = process.env.VUE_APP_FE_BASE_URL;

export default {
  computed: {
    inviteLink() {
      return `${pageUrl}/developer/join`;
    },
  },

  methods: {
    goBack() {
      this.$emit('close');
    },

    copy() {
      copyToClipboard(
        'refLink',
        this.copySucces,
        this.copyError,
      );
    },

    copySucces() {
      this.$store.dispatch('showSuccess', ['Link was copied ']);
    },

    copyError() {
      this.$store.dispatch('showError', ['Oops, unable to copy']);
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-form {
   &__link {
    display: flex;
    margin-top: 16px;
  }
  &__link-btn {
    border-radius: 4px;
    border-color: $color--secondary;
    height: 54px;
    width: 54px;
    margin-left: 16px;
  }
}
</style>
